import { FC, useEffect } from "react"
import { Box } from "@mui/material"
import { TextFieldElement, useForm } from "react-hook-form-mui"
import { StaffSchedule } from "../../interfaces"
import { ColorField } from "./colorField"

export interface ShiftTypeFormValues {
  name: string
  short_name: string
  color: string
  emoji: string
}

const DEFAULTS: ShiftTypeFormValues = {
  name: "",
  short_name: "",
  color: "#f8cbd0",
  emoji: "",
}

interface ShiftTypeFormProps {
  editing?: StaffSchedule.ShiftType | null
  onSubmit: (values: ShiftTypeFormValues) => void
  formId: string
}

/**
 * Контракт противоречит себе насчёт emoji (раздел 3 — «опциональная», раздел 4.1 — «все
 * 4 поля обязательны»): выбран строгий вариант, иначе создание может вернуть 400.
 *
 * Цвет управляется через watch/setValue, а не Controller — чтобы не тянуть прямой импорт
 * react-hook-form рядом с react-hook-form-mui.
 */
export const ShiftTypeForm: FC<ShiftTypeFormProps> = ({
  editing,
  onSubmit,
  formId,
}) => {
  const { control, handleSubmit, watch, setValue, reset } =
    useForm<ShiftTypeFormValues>({ defaultValues: DEFAULTS })

  useEffect(() => {
    reset(
      editing
        ? {
            name: editing.name,
            short_name: editing.short_name,
            color: editing.color,
            emoji: editing.emoji,
          }
        : DEFAULTS,
    )
  }, [editing, reset])

  const color = watch("color")

  return (
    <Box
      component="form"
      id={formId}
      onSubmit={handleSubmit(onSubmit)}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        pt: 1,
        minWidth: 320,
      }}
    >
      <TextFieldElement
        name="name"
        label="Название"
        control={control}
        required
        fullWidth
      />
      <TextFieldElement
        name="short_name"
        label="Короткое название"
        helperText="2–3 символа, печатается в ячейке"
        control={control}
        required
        fullWidth
      />
      <ColorField
        value={color}
        onChange={(hex) => setValue("color", hex, { shouldDirty: true })}
      />
      <TextFieldElement
        name="emoji"
        label="Emoji"
        control={control}
        fullWidth
      />
    </Box>
  )
}
